// Shared cockatiel breaker config for Amplitude `fetchV2`. Imported by both
// `pixai-server` (Koa API) and `pixai-app` (RR SSR middleware) so the policy
// can't drift across processes. Kept dependency-free (no `src/...` path
// imports) so it's safe to import from `pixai-app` via the workspace package.
import { circuitBreaker, handleAll, SamplingBreaker } from 'cockatiel'

export function createAmplitudeFetchV2Breaker() {
  return circuitBreaker(handleAll, {
    halfOpenAfter: 60_000,
    breaker: new SamplingBreaker({
      threshold: 0.5,
      duration: 30_000,
      minimumRps: 1,
    }),
  })
}
